import { loadScript } from '@crehana/utils';

import { METHODS, URLS } from 'Jsx/CheckoutV4/common/constants';

async function loadPaymentMethodScript({
  script,
  paymentMethod,
  callback = () => {},
}: {
  script: string;
  paymentMethod: string;
  callback?: (response: any) => void;
}) {
  await loadScript({ src: script })
    .then(res => {
      if (res) {
        callback(res);
      } else throw new Error(`No response from ${paymentMethod}`);
    })
    .catch(error => {
      throw new Error(`${paymentMethod} library error: ${error?.message}`);
    });
}

export function loadPayUScrip(onPayUCardScriptLoaded: () => void) {
  if (!window.payU) {
    loadPaymentMethodScript({
      script: URLS.payu,
      paymentMethod: 'PayU',
      callback: response => {
        const { PAYU_PUBLIC_KEY, PAYU_SET_URL_API, PAYU_ACCOUNT_PE } = window;

        if (response) {
          window.payU.setURL(PAYU_SET_URL_API);
          window.payU.setPublicKey(PAYU_PUBLIC_KEY);
          window.payU.setAccountID(PAYU_ACCOUNT_PE);
          window.payU.setListBoxID('mylistID');
          window.payU.setLanguage('es');
          window.payU.getPaymentMethods();
          onPayUCardScriptLoaded();
        }
      },
    });
  } else onPayUCardScriptLoaded();
}

export function loadDlocalScript(onDLocalCardScriptLoaded: () => void) {
  if (!window.dlocal) {
    loadPaymentMethodScript({
      script: URLS.dlocal,
      paymentMethod: 'dLocal',
      callback: onDLocalCardScriptLoaded,
    });
  } else onDLocalCardScriptLoaded();
}

interface ScriptLoaderParams {
  selectedPaymentMethodTitle: string | undefined;
  conektaCardScriptLoaded: boolean;
  onConektaCardScriptLoaded: () => void;
  ebanxCardScriptLoaded: boolean;
  onEbanxCardScriptLoaded: () => void;
}

export default function loadScriptsFromPaymentMethodIfNecessary({
  selectedPaymentMethodTitle = '',
  conektaCardScriptLoaded,
  ebanxCardScriptLoaded,
  onConektaCardScriptLoaded = () => {},
  onEbanxCardScriptLoaded = () => {},
}: ScriptLoaderParams) {
  switch (selectedPaymentMethodTitle) {
    case METHODS.CONEKTA_CARD:
      if (!conektaCardScriptLoaded) {
        loadPaymentMethodScript({
          script: URLS.conekta,
          paymentMethod: 'Conekta',
          callback: onConektaCardScriptLoaded,
        });
      }
      break;
    case METHODS.EBANX_CARD:
    case METHODS.EBANX_CARD_AR:
      if (!ebanxCardScriptLoaded) {
        loadPaymentMethodScript({
          script: URLS.ebanx,
          paymentMethod: 'EBANX',
          callback: onEbanxCardScriptLoaded,
        });
      }
      break;

    default:
      break;
  }
}
